/*

class to generate body site

BCM data structure

{
  "state" : "<code>" // active || pending || archive || delete
  "eocId" : "<string>"
  "conditionId" : "<string>"
  "bodySiteId" : "<string>"
  "bodySites" : "[<string>]"
  "order" : "<string>"
}

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES } = require('@bcm/constants');
const { DataTableBase } = require('./base.class');
const { identifiers, joiValidateObj } = require('../datastructComponents');
const { tbsaFormulas } = require('../codes/tbsaFormulas');
const { fluidResuscitationFormulas } = require('../codes/fluidResuscitationFormulas');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  eocId: Joi.string().required(),
  conditionId: Joi.string().required(),
  bodySiteId: Joi.string().required(),
  pathFront: Joi.string().required(),
  pathBack: Joi.string().required(),
  fileTypeFront: Joi.string().required(),
  fileTypeBack: Joi.string().required(),
  tbsaDataFront: Joi.object().required(),
  tbsaDataBack: Joi.object().required(),
  tbsaFormula: Joi.string().valid ( ...Object.keys( tbsaFormulas) ).required(),
  fluidResuscitationFormula: Joi.string().valid ( ...Object.keys( fluidResuscitationFormulas) ).required(),
  bodySitesDataFront: Joi.object().required(),
  bodySitesDataBack: Joi.object().required(),
};

// Define class
class BodySite extends DataTableBase {
  constructor ( obj ) {
    super(
      identifiers.bodySite.buildPk(obj.eocId, obj.conditionId),
      identifiers.bodySite.buildSk(obj.state, obj.eocId, obj.conditionId, obj.bodySiteId)
    );
    joiValidateObj(schema, obj);
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.BodySite = BodySite;
exports.bodySiteSchema = schema;